import { ContactDetailApi } from '../contact-detail/api/contact-detail-api';
import { ContactListApi } from '../contact-list/api/contact-list-api';

export class ContactApi {
    constructor(protected baseUrl: string) {
        this.ContactList = new ContactListApi(this.baseUrl);
        this.ContactDetail = new ContactDetailApi(this.baseUrl);
    }

    public ContactList: ContactListApi;
    public ContactDetail: ContactDetailApi;
}
